import { TerminalInfo } from "../../../src/models/types/terminals-model.types";

export type PortCall = {
  actual: boolean;
  timestamp: string | number;
  terminal?: TerminalInfo;
  terminalCode?: string;
  pilotTimestamp?: string;
};
export type CurrentSchedule = {
  inPort: boolean;
  arrival: PortCall;
  departure: PortCall;
};

export type SelectedTab = "vessels" | "ports";

export const PremiumVesselNotInNextPlatform = [9357949];

export enum AlarmLogDropdownOptions {
  OneMonth = "1 Month",
  ThreeMonth = "3 Months",
  SixMonth = "6 Months",
  TwelveMonth = "12 Months"
}

export enum NotificationType {
  reject = "BprReject",
}

export enum NotificationState {
  active = "Active",
}

export type NotificationResponse = {
  created_at: string;
  data: string; 
  ends_at: string | null;
  id: string;
  notification_id: string;
  received_at: string;
  source: string;
  state: string;
}

export type Notification = {
  id: string;
  imo_no: number;
  category: string;
  data: string;
  created_at: string;
  ends_at: string | null;
  received_at: string;
  notification_responses: NotificationResponse[];
  source: string;
  state:string;
  type: string;
  updatedAt: string;
}

export type BprRejectInfo = {
  reason?: string;
  comments?: string;
  navWarningNo?:string;
}
